"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("../../styled"));
var tokens_1 = require("../../tokens");
var container_styles_1 = __importDefault(require("../../_helpers/container-styles"));
var config = {
    basic: {
        background: tokens_1.colors.input.background,
        border: tokens_1.colors.input.border,
        hoverBorder: tokens_1.colors.input.borderHover,
        focusBorder: tokens_1.colors.input.borderFocus,
        placeholder: tokens_1.colors.input.placeholder
    },
    readOnly: {
        background: tokens_1.colors.input.backgroundReadOnly,
        border: tokens_1.colors.input.border,
        hoverBorder: tokens_1.colors.input.border,
        focusBorder: tokens_1.colors.input.border,
        placeholder: tokens_1.colors.input.placeholderReadOnly
    },
    error: {
        background: tokens_1.colors.input.background,
        border: tokens_1.colors.input.borderError,
        hoverBorder: tokens_1.colors.input.borderError,
        focusBorder: tokens_1.colors.input.borderError,
        placeholder: tokens_1.colors.input.placeholder
    }
};
var getAttributes = function (props) {
    if (props.readOnly) {
        return config.readOnly;
    }
    else if (props.hasError || props.error) {
        return config.error;
    }
    else {
        return config.basic;
    }
};
var StyledInput = styled_1.default.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  width: 100%;\n  box-sizing: border-box;\n\n  background: ", ";\n  border: 1px solid;\n  border-color: ", ";\n  border-radius: ", ";\n\n  font-family: ", ";\n  font-size: ", ";\n  color: ", ";\n\n  padding: ", " ", ";\n\n  cursor: ", ";\n  transition: border-color ", ", box-shadow ", ";\n\n  &:hover {\n    border-color: ", ";\n  }\n  &:focus {\n    border-color: ", ";\n    box-shadow: 0px 0px 0 1px ", ";\n    outline: none;\n  }\n  &::-webkit-input-placeholder {\n    color: ", ";\n  }\n"], ["\n  ", ";\n  width: 100%;\n  box-sizing: border-box;\n\n  background: ", ";\n  border: 1px solid;\n  border-color: ", ";\n  border-radius: ", ";\n\n  font-family: ", ";\n  font-size: ", ";\n  color: ", ";\n\n  padding: ", " ", ";\n\n  cursor: ", ";\n  transition: border-color ", ", box-shadow ", ";\n\n  &:hover {\n    border-color: ", ";\n  }\n  &:focus {\n    border-color: ", ";\n    box-shadow: 0px 0px 0 1px ", ";\n    outline: none;\n  }\n  &::-webkit-input-placeholder {\n    color: ", ";\n  }\n"])), container_styles_1.default, function (props) { return getAttributes(props).background; }, function (props) { return getAttributes(props).border; }, tokens_1.misc.radius, function (props) { return (props.code ? tokens_1.fonts.family.code : 'inherit'); }, function (props) { return (props.code ? '13px' : 'inherit'); }, tokens_1.colors.text.inputs, tokens_1.misc.inputs.padding, tokens_1.spacing.small, function (props) { return (props.readOnly ? 'not-allowed' : 'auto'); }, tokens_1.misc.animationDuration, tokens_1.misc.animationDuration, function (props) { return getAttributes(props).hoverBorder; }, function (props) { return getAttributes(props).focusBorder; }, function (props) { return getAttributes(props).focusBorder; }, function (props) { return getAttributes(props).placeholder; });
exports.StyledInput = StyledInput;
var templateObject_1;
//# sourceMappingURL=styled-input.js.map